import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../components/ui.module';
import { BranchShrinkData } from '../../../types';

type CellParams = ICellRendererParams<BranchShrinkData> & {
  removeCallback: (item: BranchShrinkData) => void;
};

@Component({
  selector: 'app-pan-manage-shrink-list-actions',
  imports: [UiModule, MatTooltipModule, RouterModule, MatMenuModule],
  templateUrl: './manage-shrink-list-actions.component.html',
  styleUrl: './manage-shrink-list-actions.component.scss',
})
export class ManageShrinkListActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
